var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Glyph",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 13V17C5 17.5523 5.44772 18 6 18H17C17.5523 18 18 17.5523 18 17V13H19V17C19 18.1046 18.1046 19 17 19H6C4.89543 19 4 18.1046 4 17V13H5ZM11 13.2929V5H12V13.2929L14.1464 11.1464C14.3417 10.9512 14.6583 10.9512 14.8536 11.1464C15.0488 11.3417 15.0488 11.6583 14.8536 11.8536L11.5 15.2071L8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464C8.34171 10.9512 8.65829 10.9512 8.85355 11.1464L11 13.2929Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.94d0159035e87345f80f1e0f9d3a3390.svg";
export { ForwardRef as ReactComponent };